// import React from 'react'
// import WebDevelopment from './WebDevelopment'
// import WDFAQ from './WDFAQ'
// import WDCurriculum from "./WDCurriculum"
// import Certificate from '../../Certificate'
// import WDPricing from "./WDPricing"
// export default function WDPage() {
//   return (
//     <div>
//       <WebDevelopment/>
//       <WDCurriculum/>
//       <Certificate/>
//       <WDPricing/>
//       <WDFAQ/>
//     </div>
//   )
// }

// import React from "react";
// import { motion } from "framer-motion";
// import "../../../programs.css";
// import bgImage from "../../../Image/imp1.jpg";
// import WDFAQ from "./WDFAQ";
// import WDCurriculum from "./WDCurriculum";
// import Certificate from "../../Certificate";
// import WDPricing from "./WDPricing";

// export default function WebDevelopment() {
//   return (
//     <>
//       <div className="webdev-bg" style={{ backgroundImage: `url(${bgImage})` }}>
//         <div className="program-detail-main">
//           <h1 className="program-detail-title">Web Development</h1>
//           <p className="program-detail-desc">
//             Build experiences that power the digital world. This course takes
//             you through the essentials of designing and developing modern
//             websites and applications. With businesses across every industry
//             needing strong web infrastructure, web developers remain a
//             foundational part of the global tech workforce.
//           </p>
//           <div className="program-detail-actions">
//             <button className="register-btn">Register Now</button>
//             <button className="expert-btn">Talk To Expert</button>
//           </div>
//         </div>
//       </div>

//       {/* -------------------- NEW SECTION START -------------------- */}

//       <div className="program-container">
//         {/* Left side Motion text */}
//         <motion.div
//           className="program-left1"
//           initial={{ opacity: 0, x: -100 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.7 }}
//           viewport={{ once: true }}
//         >
//           <h2 className="program-heading1">Program Overview</h2>
//           <p className="program-description1">
//             This program is designed to help you master the fundamentals of full
//             stack development. You will learn HTML, CSS, JavaScript, React,
//             Node, MongoDB, and deployment skills required to build real-world
//             applications.
//           </p>
//         </motion.div>

//         {/* Right side Motion Form */}
//         {/* <motion.form
//           className="program-form"
//           initial={{ opacity: 0, x: 100 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.7 }}
//           viewport={{ once: true }}
//         >
//           <h3>Register For Demo Class</h3>
//           <input type="text" placeholder="Enter your full name" required />
//           <input type="email" placeholder="Enter your email" required />
//           <input type="number" placeholder="Enter mobile number" required />

//           <select>
//             <option>Select Program</option>
//             <option>Web Development</option>
//             <option>App Development</option>
//             <option>Data Science</option>
//           </select>

//           <button className="submit-btn">Submit</button>
//         </motion.form> */}
//         <motion.form
//           className="program-form"
//           initial={{ opacity: 0, x: 100 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.7 }}
//           viewport={{ once: true }}
//         >
//           <h3 className="form-title">Apply Now</h3>

//           <div className="input-group">
//             <label>
//               <i className="fas fa-user"></i> Full Name
//             </label>
//             <input type="text" placeholder="Your answer" required />
//           </div>

//           <div className="input-group">
//             <label>
//               <i className="fas fa-envelope"></i> Email Address
//             </label>
//             <input type="email" placeholder="Your answer" required />
//           </div>

//           <div className="input-group">
//             <label>
//               <i className="fas fa-phone"></i> Phone Number
//             </label>
//             <input
//               type="text"
//               placeholder="+91 xxxxxxxxxx"
//               maxLength="10"
//               required
//             />
//           </div>

//           <div className="input-group">
//             <label>
//               <i className="fas fa-university"></i> College Name
//             </label>
//             <input type="text" placeholder="Your answer" required />
//           </div>

//           <div className="input-group">
//             <label>
//               <i className="fas fa-code"></i> Program
//             </label>
//             <input type="text" value="Web Development" readOnly />
//           </div>

//           <button className="submit-btn">Submit</button>
//         </motion.form>
//       </div>

//       {/* -------------------- NEW SECTION END -------------------- */}

//       <WDCurriculum />
//       <Certificate />
//       <WDPricing />
//       <WDFAQ />
//     </>
//   );
// }

import React, { useState } from "react";
import { motion } from "framer-motion";
import "../../../programs.css";
import bgImage from "../../../Image/WD.jpg";
import WDFAQ from "./WDFAQ";
import WDCurriculum from "./WDCurriculum";
import Certificate from "../../Certificate";
import SkillPage from "../../SkillPage";
import WDPricing from "./WDPricing";
import { Link } from "react-router-dom";
export default function WebDevelopment() {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    college: "",
    program: "Web Development",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbxpGr46MBF4HmNpxOYLbt2mQRcjEVPS5PtI1iZdXAMgIxORthvV4iD0Ev1zPEAsXZoK/exec";

    try {
      const res = await fetch(scriptURL, {
        method: "POST",
        body: JSON.stringify(form),
      });
      const data = await res.json().catch(() => ({}));
      if (data.status === "success" || res.ok) {
        alert("Application submitted successfully!");
        setForm({
          fullName: "",
          email: "",
          phone: "",
          college: "",
          program: "Web Development",
        });
      } else {
        if (res.ok) {
          alert("Application submitted successfully!");
          setForm({
            fullName: "",
            email: "",
            phone: "",
            college: "",
            program: "Web Development",
          });
        } else {
          console.error("Submit error:", data);
          alert("There was an error submitting the form. Try again later.");
        }
      }
    } catch (err) {
      console.error("Fetch error:", err);
      alert("Network error — please check your connection and try again.");
    }
  };

  return (
    <>
      <div className="webdev-bg" style={{ backgroundImage: `url(${bgImage})` }}>
        <div className="program-detail-main">
          <h1 className="program-detail-title">Web Development</h1>
          <p className="program-detail-desc">
          Web development turns imagination into living digital spaces. It gives businesses a voice, connects people across distances, and makes ideas accessible to anyone, anytime. It shapes first impressions, drives growth, and transforms the internet into a world we can explore, learn from, and trust.
          </p>
          <div className="program-detail-actions">
            <Link to="/register">
            <button className="register-btn">Register Now</button>
            </Link>
            <Link to="/contact-us">
            <button className="expert-btn">Talk To Expert</button>
            </Link>
          </div>
        </div>
      </div>

      {/* -------------------- NEW SECTION START -------------------- */}

      <div className="program-container">
        <motion.div
          className="program-left1"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <h2 className="program-heading1">Program Overview</h2>
          <p className="program-description1">
            The Web Development Training & Internship Program at Acadme isn’t just a program—it’s your launchpad into the digital world. With one click, endless learning begins. You won’t just study HTML, CSS, and JavaScript… you’ll build real projects, solve real problems, and watch your ideas take shape. Every module mirrors how the industry actually works, teaching teamwork, deadlines, and user-first creation. Then the internship turns skills into experience, letting you work like a professional, not just a student. This program gives you clarity, confidence, and doors to real opportunities—while others learn theory, you’ll be building your future. Enroll and create it today.
          </p>
        </motion.div>
        <motion.form
          className="program-form"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          onSubmit={handleSubmit}
        >
          <h3 className="form-title">Apply Now</h3>

          <div className="input-group">
            <label>
              <i className="fas fa-user"></i> Full Name
            </label>
            <input
              type="text"
              name="fullName"
              value={form.fullName}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-envelope"></i> Email Address
            </label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-phone"></i> Phone Number
            </label>
            <input
              type="text"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="+91 xxxxxxxxxx"
              maxLength="10"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-university"></i> College Name
            </label>
            <input
              type="text"
              name="college"
              value={form.college}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-code"></i> Program
            </label>
            <input type="text" name="program" value={form.program} readOnly />
          </div>
        
          <button className="submit-btn" type="submit">
            Submit
          </button>
        </motion.form>
      </div>

      {/* -------------------- NEW SECTION END -------------------- */}

      <WDCurriculum />
      <SkillPage />
      <Certificate />
      <WDPricing />
      <WDFAQ />
    </>
  );
}
